import type { ApolloError } from '@apollo/client';
import { $ } from '../lib/generated/zeus';
import { useTypedMutation } from '../lib/generated/zeus/apollo';

/**
 * Provides GraphQL mutation to save list of user role assignments.
 * Either deletes or creates based on the provided variables.
 * @returns custom hook that provides GraphQL mutation to mutate list of user role assignments.
 */
const useSaveUserRoleAssignments = (onError: (e: ApolloError) => void) => {
  const mutation = useTypedMutation(
    {
      insert_event_user_role_assignment_created: [
        {
          objects: $(
            'userRoleAssignmentsToCreate',
            '[event_user_role_assignment_created_insert_input]!'
          ),
        },
        {
          affected_rows: true,
        },
      ],
      insert_event_user_role_assignment_deleted: [
        {
          objects: $(
            'userRoleAssignmentsToDelete',
            '[event_user_role_assignment_deleted_insert_input]!'
          ),
        },
        {
          affected_rows: true,
        },
      ],
    },
    {
      apolloOptions: {
        onError,
      },
    }
  );

  return mutation;
};

export default useSaveUserRoleAssignments;
